




window.__DateResources =  [
    {
        today: 'Heute',
        yesterday: 'Gestern',
        daybeforeyesterday: 'Vorgestern',
        diverrormessage: 'Falsche Eingabe',
        errorinput: 'Ungültiges Datum!<br/>Format: dd.mm.yyyy',
        thismonth: 'Dieser Monat',
        lastmonth: 'Letzter Monat',
        monthbeforelastmonth: 'Vorletzter Monat',
        months: ['Jän', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        thisyear: 'Dieses Jahr',
        lastyear: 'Letztes Jahr',
        yearbeforelastyear: 'Vorletztes Jahr',
        year: 'Jahr',
        month: 'Monat',
        thisweek: 'Diese Woche',
        lastweek: 'Letzte Woche',
        weekbefore: 'Vorletzte Woche',
        weekofyear: 'Kalenderwoche',
        lastsevenyears: 'Letzte 7 Tage',
        lastfourteendaies: 'Letzte 14 Tage',
        lastthirtydaies: 'Letzte 30 Tage',
        from: "Von",
        to: 'Bis',
        lasttwomonths: 'Letzte 2 Monate',
        lastthreemonths: 'Letzte 3 Monate',
        lastsixmonths: 'Letzte 6 Monate',
        take: 'übernehmen',
        takeDateSelection: 'Datumsauswahl übernehmen'
    },
    {
        today: 'today',
        yesterday: 'yesterday',
        daybeforeyesterday: 'day before yesterday',
        diverrormessage: 'invalid input',
        errorinput: 'Invalid date!<br/>Format: dd.mm.yyyy',
        thismonth: 'this month',
        lastmonth: 'last month',
        monthbeforelastmonth: 'two months ago',
        months: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct',
            'Nov', 'Dec'
        ],
        thisyear: 'this year',
        lastyear: 'last year',
        yearbeforelastyear: 'two years ago',
        year: 'year',
        month: 'month',
        thisweek: 'this week',
        lastweek: 'last week',
        weekbefore: 'week before last week',
        weekofyear: 'week of year',
        lastsevenyears: 'last 7 days',
        lastfourteendaies: 'last 14 days',
        lastthirtydaies: 'last 30 days',
        from: "from",
        to: 'to',
        lasttwomonths: 'last 2 months',
        lastthreemonths: 'last 3 months',
        lastsixmonths: 'last 6 months',
        take: 'accept',
        takeDateSelection: 'accept date range'
    },

    {
        today: 'Oggi',
        yesterday: 'Ieri',
        daybeforeyesterday: 'L´altro ieri',
        diverrormessage: 'Inserimento non valido',
        errorinput: 'Data non valida!<br/>Format: dd.mm.yyyy',
        thismonth: 'questo mese',
        lastmonth: 'Lo scorso mese',
        monthbeforelastmonth: 'Due mesi fa',
        months: [
            'Genn', 'Febbr', 'Mar','Apr', 'Magg', 'Giugno', 'Lugio',  'Ag', 'Sett', 'Ott',
            'Nov', 'Dic'
        ],
        thisyear: 'Quest´anno',
        lastyear: 'L´anno scorso',
        yearbeforelastyear: 'Due anni fa',
        year: 'Anno',
        month: 'Mese',
        thisweek: 'Questa settimana',
        lastweek: 'La settimana scorsa',
        weekbefore: 'Settimana prima dell´ultima',
        weekofyear: 'Settimana dell´anno',
        lastsevenyears: 'Ultimi 7 giorni',
        lastfourteendaies: 'Ultimi 14 giornis',
        lastthirtydaies: 'Ultimi 30 giorni',
        from: "da",
        to: 'A',
        lasttwomonths: 'Ultimi 2 mesi',
        lastthreemonths: 'Ultimi 3 mesi',
        lastsixmonths: 'Ultimi 6 mesi',
        take: 'accettare',
        takeDateSelection: 'accetta l´intervallo di date'
    },






    //ÜBERSETZTEN KROATISCH
    {
        today: 'danas',
        yesterday: 'jučer',
        daybeforeyesterday: 'prekjučer',
        diverrormessage: 'pogrešan unos',
        errorinput: 'nevažeći datum!<br/>Format: dd.mm.yyyy',
        thismonth: 'ovaj mjesec',
        lastmonth: 'prošli mjesec',
        monthbeforelastmonth: 'prije dva mjeseca',
        months: ['siječnja','veljača','ožujak','travanj','svibanj','lipanj','srpanj','kolovoz','rujan','listopad','studeni','prosinac'],
        thisyear: 'ove godine',
        lastyear: 'prošle godine',
        yearbeforelastyear: 'prije dvije godine',
        year: 'godina',
        month: 'mjesec',
        thisweek: 'ovaj tjedan',
        lastweek: 'prošli tjedan',
        weekbefore: 'pretprošli tjedan',
        weekofyear: 'tjedan u godini',
        lastsevenyears: 'posljednjih 7 dana',
        lastfourteendaies: 'posljednjih 14 dana',
        lastthirtydaies: 'posljednjih 30 dana',
        from: "iz",
        to: 'do',
        lasttwomonths: 'zadnja 2 mjeseca',
        lastthreemonths: 'zadnja 3 mjeseca',
        lastsixmonths: 'zadnja 6 mjeseca',
        take: 'prihvatiti',
        takeDateSelection: 'prihvatiti raspon datuma'
    },
    //ÜBERSETZEN POLNISCH
    {
        today: 'Dzisiaj',
        yesterday: 'Wczoraj',
        daybeforeyesterday: 'przedwczoraj',
        diverrormessage: 'nieprawidłowe dane wejściowe',
        errorinput: 'nieprawidłowa data!<br/>Format: dd.mm.yyyy',
        thismonth: 'ten miesiąc',
        lastmonth: 'w zeszłym miesiącu',
        monthbeforelastmonth: 'dwa miesiące temu',
        months: ['styczeń','luty','Marsz','Kwiecień','Móc','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'],
        thisyear: 'w tym roku',
        lastyear: 'ostatni rok',
        yearbeforelastyear: 'dwa lata temu',
        year: 'rok',
        month: 'miesiąc',
        thisweek: 'w tym tygodniu',
        lastweek: 'zeszły tydzień',
        weekbefore: 'tydzień przed zeszłym tygodniem',
        weekofyear: 'tydzień roku',
        lastsevenyears: 'ostatnie 7 dni',
        lastfourteendaies: 'ostatnie 14 dni',
        lastthirtydaies: 'ostatnie 30 dni',
        from: "z",
        to: 'do',
        lasttwomonths: 'ostatnie 2 miesiące',
        lastthreemonths: 'ostatnie 3 miesiące',
        lastsixmonths: 'ostatnie 6 miesiące',
        take: 'zaakceptować',
        takeDateSelection: 'zaakceptuj zakres dat'
    },
    //ÜBERSETZEN TSCHECHISCH
    {
        today: 'dnes',
        yesterday: 'včera',
        daybeforeyesterday: 'předevčírem',
        diverrormessage: 'neplatný vstup',
        errorinput: 'neplatné datum!<br/>Format: dd.mm.yyyy',
        thismonth: 'tento měsíc',
        lastmonth: 'minulý měsíc',
        monthbeforelastmonth: 'před dvěma měsíci',
        months: ['leden', 'únor', 'březen', 'duben','květen','červen','červenec','srpen','září','říjen','listopad','prosinec'],
        thisyear: 'tento rok',
        lastyear: 'minulý rok',
        yearbeforelastyear: 'před dvěma lety',
        year: 'rok',
        month: 'měsíc',
        thisweek: 'tento týden',
        lastweek: 'minulý týden',
        weekbefore: 'týden před minulým týdnem',
        weekofyear: 'týden v roce',
        lastsevenyears: 'posledních 7 dní',
        lastfourteendaies: 'posledních 14 dní',
        lastthirtydaies: 'posledních 30 dní',
        from: "z",
        to: 'na',
        lasttwomonths: 'poslední 2 měsíce',
        lastthreemonths: 'poslední 3 měsíce',
        lastsixmonths: 'poslední 6 měsíce',
        take: 'akceptovat',
        takeDateSelection: 'přijmout časové období'
    },
    //FRANZÖSISCH
    {
        today: 'aujourd\u2019hui',
        yesterday: 'hier',
        daybeforeyesterday: 'avant-hier',
        diverrormessage: 'saisie incorrecte',
        errorinput: 'Date invalide !<br/>Format : dd.mm.yyyy',
        thismonth: 'ce mois',
        lastmonth: 'mois dernier',
        monthbeforelastmonth: 'il y a deux mois',
        months: ['janv.', 'f\u00e9vr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'ao\u00fbt', 'sept.', 'oct.', 'nov.', 'd\u00e9c.'],
        thisyear: 'cette ann\u00e9e',
        lastyear: 'ann\u00e9e derni\u00e8re',
        yearbeforelastyear: 'il y a deux ans',
        year: 'ann\u00e9e',
        month: 'mois',
        thisweek: 'cette semaine',
        lastweek: 'semaine derni\u00e8re',
        weekbefore: 'avant-derni\u00e8re semaine',
        weekofyear: 'semaine de l\u2019ann\u00e9e',
        lastsevenyears: 'derniers 7 jours',
        lastfourteendaies: 'derniers 14 jours',
        lastthirtydaies: 'derniers 30 jours',
        from: "du",
        to: 'au',
        lasttwomonths: 'derniers 2 mois',
        lastthreemonths: 'derniers 3 mois',
        lastsixmonths: 'derniers 6 mois',
        take: 'accepter',
        takeDateSelection: 'accepter la p\u00e9riode'
    }





];




    window.__OptionBoxResources = [
        { defaultCaption: 'Auswahl', date: 'Datum', interval: "Intervall" },
        { defaultCaption: 'selection', date: 'date', interval: "interval"  },
        { defaultCaption: 'Selezione', date: 'Data', interval: "Intervalli" },
        //ÜBERSETZEN KROATISCH
        { defaultCaption: 'izbor', date: 'datum', interval: "interval" },
        //ÜBERSETZEN POLNISCH
        { defaultCaption: 'wybór', date: 'data', interval: "interwał" },
        //ÜBERSETZEN TSCHECHISCH 
        { defaultCaption: 'v\u00fdb\u011br', date: 'datum', interval: "interval" },
        //FRANZÖSISCH
        { defaultCaption: 's\u00e9lection', date: 'date', interval: "intervalle" }
    ];


window.__CalendarFilterResources = {
    "en": {
        calendar: "Calendar",
        button: {
            firstPage: "Period",
            secondPage: "Ignores",
            thirdPage: "Holidays",
            fromToAdd: "New",
            abort: "Abort",
            save: "Save",
            vcDate: {
                thisweek: "This Week",
                lastweek: "Last Week",
                thismonth: "This Month",
                lastmonth: "Last Month",
                thisyear: "This Year",
                lastyear: "Last Year"
            }
        },
        label: {
            months: "Months",
            weekDays: "Weekdays",
            timer: "activation times",
            //fromToList: "Created Periods",
            fromToList: "Editable list of self-created alarm-free periods",
            ignores: "Ignores",
            checkAll: "Check all",
            holidays: "Use holidays",
            holidayYearly: "yearly"
        },
        rangePopupTitle: "Save new Custom Date Range",
        rangeDescription: "Description"
    },
    "de": {
        calendar: "Kalender",
        button: {
            firstPage: "Zeitraum",
            secondPage: "Ausnahmen",
            thirdPage: "Feiertage",
            fromToAdd: "Neu",
            abort: "Abbruch",
            save: "Speichern",
            vcDate: {
                thisweek: "Diese Woche",
                lastweek: "Letzte Woche",
                thismonth: "Dieser Monat",
                lastmonth: "Letzter Monat",
                thisyear: "Dieses Jahr",
                lastyear: "Letztes Jahr"
            }
        },
        label: {
            months: "Monate",
            weekDays: "Wochentage",
            timer: "Aktivierungszeiten",
            fromToList: "Editierbare Auflistung der eigenerstellten alarmfreien Zeiträume",
            ignores: "Ausnahmen",
            checkAll: "Alle auswählen",
            holidays: "Feiertage übernehmen",
            holidayYearly: "jährlich"
        },
        rangePopupTitle: "Neue Zeitspanne eintragen",
        rangeDescription: "Beschreibung"
    },


    "it": {
        calendar: "Calendario",
        button: {
            firstPage: "Periodo",
            secondPage: "Eccezioni",
            thirdPage: "Feste pubbliche",
            fromToAdd: "nuovo",
            abort: "cancellazione",
            save: "salvare",
            vcDate: {
                thisweek: "Questa settimana",
                lastweek: "Settimana scorsa",
                thismonth: "Questo mese",
                lastmonth: "Scorso mese",
                thisyear: "Questo anno",
                lastyear: "Scorso anno"
            }
        },
        label: {
            months: "Mesi",
            weekDays: "Giorni della settimana",
            timer: "Tempi di attivazione",
            fromToList: "Elenco modificabile di periodi senza allarmi auto-creati",
            ignores: "Eccezioni",
            checkAll: "Seleziona tutto",
            holidays: "prendere in vacanza",
            holidayYearly: "annuale"
        },
        rangePopupTitle: "Inserisci un nuovo intervallo di tempo",
        rangeDescription: "Descrizione"
    },

    //ÜBERSETZEN KROATISCH
    "hr": {
       calendar: "kalendar",
        button: {
            firstPage: "razdoblje",
            secondPage: "ignorira",
            thirdPage: "Praznici",
            fromToAdd: "novi",
            abort: "prekid",
            save: "uštedjeti",
            vcDate: {
                thisweek: "ovaj tjedan",
                lastweek: "prošli tjedan",
                thismonth: "ovaj mjesec",
                lastmonth: "prošli mjesec",
                thisyear: "ove godine",
                lastyear: "prošle godine"
            }
        },
        label: {
            months: "mjeseca",
            weekDays: "radnim danima",
            timer: "vremena aktivacije",
            //fromToList: "Created Periods",
            fromToList: "Popis razdoblja bez alarma koje ste sami izradili možete uređivati",
            ignores: "ignorira",
            checkAll: "provjeri sve",
            holidays: "koristiti praznike",
            holidayYearly: "godišnje"
        },
        rangePopupTitle: "Spremi novi prilagođeni datumski raspon",
        rangeDescription: "opis"
    },

    //ÜBERSETZEN POLNISCH
    "pl": {
        calendar: "kalendarz",
        button: {
            firstPage: "okres",
            secondPage: "ignoruje",
            thirdPage: "wakacje",
            fromToAdd: "nowy",
            abort: "anulować",
            save: "ratować",
            vcDate: {
                thisweek: "w tym tygodniu",
                lastweek: "zeszły tydzień",
                thismonth: "ten miesiąc",
                lastmonth: "w zeszłym miesiącu",
                thisyear: "w tym roku",
                lastyear: "ostatni rok"
            }
        },
        label: {
            months: "miesiące",
            weekDays: "dni powszednie",
            timer: "czasy aktywacji",
            fromToList: "Edytowalna lista samodzielnie utworzonych okresów wolnych od alarmów",
            ignores: "Ignoruje",
            checkAll: "Zaznacz wszystkie",
            holidays: "korzystać z wakacji",
            holidayYearly: "rocznie"
        },
        rangePopupTitle: "Zapisz nowy niestandardowy zakres dat",
        rangeDescription: "opis"
    },


    //ÜBERSETZEN TSCHECHISCH
    "cz": {
        calendar: "kalendář",
        button: {
            firstPage: "doba",
            secondPage: "ignoruje",
            thirdPage: "dovolená",
            fromToAdd: "nový",
            abort: "přerušit",
            save: "uložit",
            vcDate: {
                thisweek: "tento týden",
                lastweek: "minulý týden",
                thismonth: "tento měsíc",
                lastmonth: "minulý měsíc",
                thisyear: "tento rok",
                lastyear: "minulý rok"
            }
        },
        label: {
            months: "měsíce",
            weekDays: "všední dny",
            timer: "aktivační časy",
            fromToList: "Upravitelný seznam samostatně vytvořených období bez alarmu",
            ignores: "ignoruje",
            checkAll: "zkontrolovat vše",
            holidays: "využít dovolené",
            holidayYearly: "roční"
        },
        rangePopupTitle: "uložit nové vlastní časové období",
        rangeDescription: "popis"
    },

    //FRANZÖSISCH
    "fr": {
        calendar: "Calendrier",
        button: {
            firstPage: "P\u00e9riode",
            secondPage: "Exceptions",
            thirdPage: "Jours f\u00e9ri\u00e9s",
            fromToAdd: "Nouveau",
            abort: "Annuler",
            save: "Enregistrer",
            vcDate: {
                thisweek: "Cette semaine",
                lastweek: "Semaine derni\u00e8re",
                thismonth: "Ce mois",
                lastmonth: "Mois dernier",
                thisyear: "Cette ann\u00e9e",
                lastyear: "Ann\u00e9e derni\u00e8re"
            }
        },
        label: {
            months: "Mois",
            weekDays: "Jours de la semaine",
            timer: "temps d\u2019activation",
            fromToList: "Liste modifiable des p\u00e9riodes sans alarme cr\u00e9\u00e9es",
            ignores: "Exceptions",
            checkAll: "Tout s\u00e9lectionner",
            holidays: "Appliquer jours f\u00e9ri\u00e9s",
            holidayYearly: "annuel"
        },
        rangePopupTitle: "Enregistrer une nouvelle p\u00e9riode personnalis\u00e9e",
        rangeDescription: "Description"
    },


    "months": {
        short: [],
        long: []
    },
    "weekDays": {
        short: [],
        long: []
    }
}


//global function for getting language shortcut from language id
function getLanguageShortcut(langID) {
    var shortcut = "en";

    //set lang
    switch (langID) {
        case 2:
            shortcut = "de";
            break;
        case 3:
            shortcut = "en";
            break;
        case 4:
            shortcut = "it";
            break;
        case 5:
            shortcut = "hr";
            break;
        case 6:
            shortcut = "pl";
            break;
        case 7:
            shortcut = "cz";
            break;
        case 8:
            shortcut = "fr";
            break;
        default:
            shortcut = "en";
            break;
    }
    return shortcut;
}


